module.exports = __webpack_public_path__ + "static/media/KingArthur.38c1e82a.jpg";